export default {
  featherIcon: {
    types: Object.freeze({
      DOLLAR_SIGN_ICON: 'DollarSignIcon', PHONE_ICON: 'PhoneIcon', INFO_ICON: 'InfoIcon', SETTINGS_ICON: 'SettingsIcon',
      USERS_ICON: 'UsersIcon', EXTERNAL_LINK_ICON: 'ExternalLinkIcon', ARROW_DOWN_ICON: 'ArrowDownIcon',
      ARROW_UP_ICON: 'ArrowUpIcon', CLOCK_ICON: 'ClockIcon', ARROW_UP_CIRCLE_ICON: 'ArrowUpCircleIcon',
      ARROW_DOWN_CIRCLE_ICON: 'ArrowDownCircleIcon', FILTER_ICON: 'FilterIcon', TRASH_ICON: 'TrashIcon',
      X_ICON: 'XIcon', ARROW_UP_RIGHT_ICON: 'ArrowUpRightIcon', HOME_ICON: 'HomeIcon', USER_ICON: 'UserIcon',
      EYE_ICON: 'EyeIcon', BOOK_OPEN_ICON: 'BookOpenIcon', FILE_TEXT_ICON: 'FileTextIcon', EDIT_ICON: 'EditIcon',
      REFRESH_CW_ICON: 'RefreshCwIcon', COPY_ICON : 'CopyIcon', TOOL_ICON: 'ToolIcon', X_OCTAGON_ICON: 'XOctagonIcon',
      CHECK_CIRCLE_ICON: 'CheckCircleIcon', MINUS_ICON: 'MinusIcon', LINK_ICON: 'LinkIcon', FOLDER_ICON: 'FolderIcon',
      MAIL_ICON: 'MailIcon', LOG_OUT_ICON: 'LogOutIcon', CIRCLE_ICON : 'CircleIcon', DISC_ICON : 'DiscIcon',
      BELL_ICON: 'BellIcon', ALERT_TRIANGLE_ICON: 'AlertTriangleIcon', ALERT_CIRCLE_ICON: 'AlertCircleIcon',
      SEARCH_ICON: 'SearchIcon', LOG_IN_ICON: 'LogInIcon', SAVE_ICON: 'SaveIcon', ARCHIVE_ICON: 'ArchiveIcon',
    }),
  },
  emitEvents: Object.freeze({
    CLICK: 'click', CONFIRM: 'confirm', HIDE: 'hide', CANCEL: 'cancel', CLOSE: 'close', CHANGE: 'change',
    CLICK_TOAST: 'click-toast', ARROW_CLICK: 'arrow-click', OPEN_SETTINGS: 'open-settings', CLEAR: 'clear',
    OPEN_FILTERS: 'open-filters', RESET: 'reset', SAVE: 'save', LOADED: 'loaded', INPUT: 'input', GO_BACK : 'go-back',
    OPEN_ADDITIONAL_WORK_SHIFT_EDIT_FORM: 'open-additional-work-shift-edit-form', EXPORT_START: 'export-start',
    ADDITIONAL_WORK_SHIFT_REMOVED: 'additional-work-shift-removed', EXPORT_FINISH: 'export-finish',
    ADDITIONAL_WORK_SHIFT_EDITED: 'additional-work-shift-edited', ACTION_START: 'action-start',
    ADDITIONAL_WORK_SHIFT_CREATED: 'additional-work-shift-created', ACTION_FINISH: 'action-finish', SELECT: 'select',
  }),
  bModalSizes: Object.freeze({ XL: 'xl', LG: 'lg', MD: 'md', XS: 'xs' }),
  stateTable: Object.freeze({ PAGE_LIMIT: 'page-limit' }),
}
